export default __webpack_public_path__ + "static/budgeting-bg-856f60aa58d79148622faefe2b2a266f.jpg";